/** Режим страницы загрузки: создание новой вещи или редактирование существующей. */
export const uploadModeCreate = "create";
export const uploadModeEdit = "edit";

// Дефолтные значения для dropdown'ов
export const chooseBuyer = 'Choose Buyer'
export const chooseLocation = 'Choose Location'
export const chooseBrand = 'Choose Brand'
export const chooseType = 'Choose Type'
export const chooseStatus = 'Choose Status'

// Дефолтный id для dropdown'ов
export const defaultID = ''

// Подписи кнопок формы. Title Case как у остальных видимых строк (см. chooseX выше).
export const buttonUpload = 'Upload'
export const buttonSave = 'Save'
